import {addHours} from 'date-fns';

import {isNil} from 'ramda';

import {TestDriveCalendarDrive} from '@dms/api/sales';

import {parseDate} from 'shared/web';

import {TEST_DRIVE_CALENDAR} from '../constants/TEST_DRIVE_CALENDAR';
import {clampToBusinessWindow} from './clampToBusinessWindow';
import {getRowCollisionLayout} from './getRowCollisionLayout';
import {splitAcrossMidnight} from './splitAcrossMidnight';

export type TestDriveSegment = {
  key: string;
  drive: TestDriveCalendarDrive;
  start: Date;
  end: Date;
  /** Unclamped bounds — the label and tooltip show these, not the clamped ones. */
  actualStart: Date;
  actualEnd: Date;
  isClampedStart: boolean;
  isClampedEnd: boolean;
  isContinuation: boolean;
  lane: number;
  laneCount: number;
};

/** A drive with no end is drawn as one hour — the same default the backend's overlap test uses. */
export const getVehicleDriveSegments = (drives: TestDriveCalendarDrive[]): TestDriveSegment[] => {
  const rawSegments = drives.flatMap((drive) => {
    const start = parseDate(drive.scheduledAt);
    const end = isNil(drive.returnedAt)
      ? addHours(start, TEST_DRIVE_CALENDAR.OPEN_DRIVE_HOURS)
      : parseDate(drive.returnedAt);

    return splitAcrossMidnight(start, end).map((segment, segmentIndex) => {
      const clamped = clampToBusinessWindow(segment.start, segment.end);

      return {
        key: `${drive.testDriveId}-${segmentIndex}`,
        drive,
        start: clamped.start,
        end: clamped.end,
        actualStart: start,
        actualEnd: end,
        isClampedStart: clamped.isClampedStart,
        isClampedEnd: clamped.isClampedEnd,
        isContinuation: segmentIndex > 0,
      };
    });
  });

  return getRowCollisionLayout(rawSegments);
};
